import { Constant } from '../constants/constant';
import {
  RvsfBranchFormValue,
  RvsfBranchRequest,
  RvsfBranchResponse,
} from '../models/rvsf-branch.model';

export class RvsfBranchMapper {
  // API → FORM
  static toForm(data: RvsfBranchResponse['data']): RvsfBranchFormValue {
    return {
      rvsfId: data.rvsf_id,
      rvsfName: data.rvsf_name || '',
      branchName: data.branch_name || '',
      address1: data.branch_address_line_1 || '',
      address2: data.branch_address_line_2 || '',
      branch_pincode_id: data.branch_pincode_id || null,
      pincode: data.pincode || null,

      contactPerson: data.branch_contact_person || '',
      contactMobile: data.branch_contact_mobile_number || '',
      contactEmail: data.branch_contact_email_id || '',

      toleranceLimit: data.tolerance_limit_perc ?? '',

      gstNo: data.gst_no || '',
      cinNo: data.cin_no || '',
      registrationNo: data.registration_number || '',

      lAuthorized: data.l_authorized ?? '',
      mAuthorized: data.m_authorized ?? '',
      nAuthorized: data.n_authorized ?? '',
      oAuthorized: data.o_authorized ?? '',

      rvsfValidityDate: data.rvsf_validity_dt || null,

      gstPath: data.gst_document_path || null,

      cinPath: data.cin_file_path || null,
      signaturePath: data.authorized_signature_path || null,
    };
  }

  // FORM → API REQUEST
  static toRequest(form: RvsfBranchFormValue): RvsfBranchRequest {
    return {
      rvsf_id: Number(form.rvsfId),

      branch_name: form.branchName?.trim() || '',
      branch_address_line_1: form.address1?.trim() || '',
      branch_address_line_2: form.address2?.trim() || '',
      branch_pincode_id: Number(form.pincode) || 0,

      branch_contact_person: form.contactPerson?.trim() || '',
      branch_contact_mobile_number: form.contactMobile?.trim() || '',
      branch_contact_email_id: form.contactEmail?.trim() || '',

      tolerance_limit_perc: Number(form.toleranceLimit) || 0,

      gst_no: form.gstNo?.trim() || '',
      registration_number: form.registrationNo?.trim() || '',
      cin_no: form.cinNo?.trim() || '',

      l_authorized: Number(form.lAuthorized) || 0,
      m_authorized: Number(form.mAuthorized) || 0,
      n_authorized: Number(form.nAuthorized) || 0,
      o_authorized: Number(form.oAuthorized) || 0,

      rvsf_validity_dt: form.rvsfValidityDate || '',

      gst_document_file: form.gstPath instanceof File ? form.gstPath : null,

      cin_file: form.cinPath instanceof File ? form.cinPath : null,

      authorized_signature: form.signaturePath instanceof File ? form.signaturePath : null,
    };
  }
}
